import Service from './Service';
import {SERVER_URL} from "../utils/Constants";
import GeneralUtils from "../utils/GeneralUtils";

export default class WorkFlowProcessService extends Service {
    constructor() {
        super();
        this.baseURL = 'workFlowProcess';
    }

    findByCategoryIdAndSubcategoryId(categoryId, subcategoryId) {
        return fetch(SERVER_URL + this.baseURL + '/findByCategoryIdAndSubcategoryId/' + categoryId +'/'+subcategoryId, {
            headers: {'Content-Type': 'application/json', Authorization: localStorage.getItem("Authorization")}
        }).then(response => response.json()).catch(error => {
            GeneralUtils.notification(error);
        });
    }

}